const GALLERY_ITEMS_TYPES = Object.freeze({
  IMAGE: "image",
  VIDEO: "video"
});
const DEFAULTS = Object.freeze({
  containerData: {
    alignment: "CENTER",
    width: {
      size: "CONTENT"
    }
  }
});
export {
  DEFAULTS,
  GALLERY_ITEMS_TYPES
};
//# sourceMappingURL=defaults.js.map
